<div
  class="question-node flex flex-col gap-2 p-3 rounded-xl bg-white shadow-sm hover:shadow-md transition-all duration-200"
  [class.error]="shouldHighlightQuestion"
  [formGroup]="question"
  [style.width]="width"
>
  <div class="question-row flex flex-row items-center gap-2">
    <mat-icon
      class="drag text-gray-500 cursor-move"
      cdkDragHandle
      matTooltip="Drag to reorder question"
    >
      drag_indicator
    </mat-icon>

    <b
      class="flex items-center justify-center text-xs text-gray-600 w-6 h-6 rounded-full bg-gray-100 font-medium"
    >
      {{ label }}
    </b>

    <textarea
      matInput
      cdkTextareaAutosize
      cdkAutosizeMinRows="1"
      cdkAutosizeMaxRows="5"
      formControlName="question"
      placeholder="Enter question..."
      class="flex-grow bg-transparent resize-none text-sm"
      data-test-id="question-node-question-text-input"
      [id]="inputId"
      (keydown)="onKeydown($event)"
    ></textarea>

    <mat-icon
      data-test-id="question-node-question-options-dropdown"
      [matMenuTriggerFor]="menu"
      (click)="$event.stopPropagation()"
      >more_horiz</mat-icon
    >

    <mat-menu #menu="matMenu">
      @if (depth < maxDepth) {
        <button
          mat-menu-item
          data-test-id="question-node-add-sub-question-button"
          (click)="addQuestion(themeIndex, question)"
        >
          <mat-icon>add</mat-icon>
          <span>Add sub-question</span>
        </button>
      }

      <button
        mat-menu-item
        data-test-id="question-node-remove-question-button"
        (click)="removeQuestion(themeIndex, question)"
      >
        <mat-icon>close</mat-icon>
        <span>Remove</span>
      </button>
    </mat-menu>
  </div>

  @if (children.controls.length) {
    <div
      formArrayName="children"
      class="child-question-list flex flex-col gap-2 mt-2 border-l-2 border-gray-200 pl-4"
      cdkDropList
      [id]="dropListId"
      [cdkDropListData]="children.controls"
      [cdkDropListConnectedTo]="connectedDropLists"
      (cdkDropListDropped)="onChildDrop($event)"
    >
      @for (child of children.controls; track child) {
        <app-question-node
          cdkDrag
          [formGroupName]="$index"
          [parentForm]="parentForm"
          [question]="child"
          [themeIndex]="themeIndex"
          [depth]="depth + 1"
          [index]="$index"
          [addQuestion]="addQuestion"
          [removeQuestion]="removeQuestion"
          [showErrors]="showErrors"
        ></app-question-node>
      }
    </div>
  }
</div>
